module.exports = __webpack_public_path__ + "media/bg_video1.620b9f37.mp4";